import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { FONTS, SPACES } from 'src/constants'

// Styles used with impact types & impact periods.
export const useStyles = makeStyles((theme: Theme) => ({
  btn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '40px',
  },
  modalWrapper: {
    minHeight: 360,
    [theme.breakpoints.down('tablet')]: {
      minWidth: 320,
    },
    [theme.breakpoints.up('tablet')]: {
      minWidth: 400,
    },

    padding: SPACES.xxl,
  },
  formWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: SPACES.xxxxl,
    },
  },
  formWrapperWithHeight: {
    '&&': {
      minHeight: 320,
    },
  },
  inputsWrapper: {
    '&&': {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: SPACES.m,
      maxHeight: '75vh',
      overflowY: 'auto',

      [theme.breakpoints.down('tablet')]: {
        maxHeight: '65vh',
      },
    },
  },
  title: {
    '&&': {
      fontSize: FONTS.SIZES.xxl,
      fontWeight: FONTS.WEIGHTS.bold,
      lineHeight: 1.4,
      textAlign: 'center',

      color: theme.palette.custom.darkBlue2,
    },
  },
  inputHolder: {
    '&&': {
      width: '100%',
    },
  },

  imageHolder: {
    minHeight: '60px',
    height: '60px',
    width: '60px',
    borderRadius: '30px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundColor: theme.palette.custom.darkBlue2,
  },
  warningText: {
    '&&': {
      color: theme.palette.custom.warning2,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.4,
    },
  },
  colorHolder: {
    height: '25px',
    width: '25px',
    borderRadius: '5px',
  },
  additionButton: {
    '&&': {
      [theme.breakpoints.down('tablet')]: {
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 40,
        marginBottom: 40,
      },
      [theme.breakpoints.up('tablet')]: {
        marginLeft: '135px',
        marginTop: 40,
        marginBottom: 40,
      },
    },
  },
  cardsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.l,
  },
  cardWrapper: {
    '&&': {
      backgroundColor: theme.palette.custom.white,
      border: `1px solid ${theme.palette.custom.grey}`,
      borderRadius: '10px',
      boxShadow: 'none',

      width: 'calc(100vw - 40px)',
    },
  },
  cardContent: {
    '&&': {
      padding: SPACES.m,

      display: 'flex',
      justifyContent: 'space-between',

      color: theme.palette.custom.darkBlue2,
    },
  },
  itemWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  cardLeftWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      gap: 20,
      alignItems: 'start',
      maxWidth: '75%',
    },
  },
  cardName: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.m,
      lineHeight: 1.35,
      color: 'inherit',
    },
  },
  cardCategory: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.light,
      fontSize: FONTS.SIZES.xs,
      lineHeight: 1.4,
      color: 'inherit',
    },
  },
  buttonsWrapper: {
    display: 'flex',
  },
  orderIcon: {
    '&&': {
      color: theme.palette.custom.grey2,
      '&:disabled': {
        color: theme.palette.custom.grey,
      },
    },
  },
  itemTitle: {
    margin: 0,

    [theme.breakpoints.down('tablet')]: {
      fontWeight: FONTS.WEIGHTS.light,
      fontSize: FONTS.SIZES.s,

      lineHeight: 1.33,
      color: theme.palette.custom.grey2,
    },
    [theme.breakpoints.up('tablet')]: {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.xl,
      lineHeight: 1.4,

      color: theme.palette.custom.darkBlue2,
    },
  },
  checkboxWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))
